import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/reshark.webp';
import screenshot_target from '../../../images/letterfunnel/wesleypeeters.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Wesley Peeters"
      firstname="Wesley"
      companyname="Re:Shark"
      competition="Apollo.io en 11x.ai"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/wesleypeeters.js